import { render, staticRenderFns } from "./AdminUser.vue?vue&type=template&id=bcafd20e&scoped=true&"
import script from "./AdminUser.vue?vue&type=script&lang=js&"
export * from "./AdminUser.vue?vue&type=script&lang=js&"
import style0 from "./AdminUser.vue?vue&type=style&index=0&id=bcafd20e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcafd20e",
  null
  
)

export default component.exports